import axios from "axios";
import { BASE_URL } from "./requests";
import { toast } from "react-toastify";
import { useLoading } from "app/hooks/contexts/LoadingContext";
import { useCallback } from "react";

// Configuração do axios
export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  timeout: 50000
});

// Interceptor para respostas de sucesso
api.interceptors.response.use(
  (response) => {
    if (response.config.showToast !== false && response.config.method !== "get") {
      toast.success(response?.data?.message || "Operação realizada com sucesso", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: {
          height: "44px !important",
          display: "flex",
          alignItems: "center"
        }
      });
    }
    return response;
  },
  (error) => {
    const errorMessage = error?.response?.data?.message;
    if (error.config.showToast === false) {
      return Promise.reject(error);
    } else if (Array.isArray(errorMessage)) {
      // Exibe apenas o primeiro erro, se for um array
      toast.error(errorMessage[0], {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored"
      });
    } else {
      toast.error(errorMessage || "Erro na operação", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored"
      });
    }
    return Promise.reject(error);
  }
);

// Funções de chamadas API com toast
export async function getFromApi(resource, config = {}) {
  return api.get(resource, config);
}

export async function postFromApi(resource, data, config = {}) {
  return api.post(resource, data, config);
}

export async function patchFromApi(resource, data, config = {}) {
  return api.patch(resource, data, config);
}

export async function deleteFromApi(resource, config = {}) {
  return api.delete(resource, config);
}

// Funções de chamada API com loader
export const useApiHookLoader = () => {
  const { showLoader, hideLoader } = useLoading();

  const get = useCallback(
    async (url, config) => {
      showLoader();
      try {
        const response = await getFromApi(url, config);
        return response;
      } finally {
        hideLoader();
      }
    },
    [showLoader, hideLoader]
  );

  const post = useCallback(
    async (url, data, config) => {
      showLoader();
      try {
        const response = await postFromApi(url, data, config);
        return response;
      } finally {
        hideLoader();
      }
    },
    [showLoader, hideLoader]
  );

  const patch = useCallback(
    async (url, data, config) => {
      showLoader();
      try {
        const response = await patchFromApi(url, data, config);
        return response;
      } finally {
        hideLoader();
      }
    },
    [showLoader, hideLoader]
  );

  const del = useCallback(
    async (url, config) => {
      showLoader();
      try {
        const response = await deleteFromApi(url, config);
        return response;
      } finally {
        hideLoader();
      }
    },
    [showLoader, hideLoader]
  );

  return { get, post, patch, del };
};
